module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/orders.component.css
// module id = ./src/app/orders/orders.component.css
// module chunks = main